/**
 * Phase 6-C — Client Portal route guard.
 *
 * Reads the magic-link access token from Redux. If absent OR expired,
 * redirects to `/client-portal/expired`. Otherwise renders the children.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

interface Props {
  children: React.ReactElement;
}

const ClientPortalProtectedRoute: React.FC<Props> = ({ children }) => {
  const token = useSelector(
    (s: RootState) => s.auth.clientPortal.accessToken
  );
  const expiresAt = useSelector(
    (s: RootState) => s.auth.clientPortal.expiresAt
  );

  const isExpired =
    typeof expiresAt === 'number' && expiresAt > 0 && Date.now() >= expiresAt;

  if (!token || isExpired) {
    return <Navigate to='/client-portal/expired' replace />;
  }
  return children;
};

export default ClientPortalProtectedRoute;
